import { ShopperProductsTypes } from 'commerce-sdk-isomorphic';

/**
 * A gallery item. Salesforce gives images as objects and product videos as bare links, so the
 * two travel together in one list and are told apart by shape.
 */
export type Media = ShopperProductsTypes.Image | string;

export const isVideo = (media: Media): media is string => typeof media === 'string';
